import InviteFriendPage from './InviteFriendPage'

export default InviteFriendPage
// eslint-disable-next-line import/export
export * from './InviteFriendPage'
